import React from 'react';
import PropTypes from 'prop-types';
import Winner from './Winner';
import { WinnersContainer } from '../PlayerOfTheGame.style';

const WinnersDisplay = ({
    winners,
    deviceInteraction,
    language,
    isLoadingStories,
    trackingProps
}) => {
    return (
        <WinnersContainer>
            {winners.map(winner => {
                return <Winner trackingProps={trackingProps} winner={winner} key={winner.feedId} deviceInteraction={deviceInteraction} language={language} isLoadingStories={isLoadingStories}/>;
            })}
        </WinnersContainer>
    );
};

WinnersDisplay.propTypes = {
    winners: PropTypes.array,
    voteLink: PropTypes.string,
    deviceInteraction: PropTypes.object,
    componentName: PropTypes.string,
    language: PropTypes.string,
    isLoadingStories: PropTypes.bool,
    trackingProps: PropTypes.bool
};
export default WinnersDisplay;
